import { NotificationModule } from "./NotificationModule";

export const notificationModules: NotificationModule[] = [];
